import React from 'react'
import HeaderDropDownMenu from './HeaderDropDownMenu';

const HeaderSubMenu = (props) => {
	const { data: wData = {}, id = '', title = '', faIconClass = '' } = props,
		{ data = {}, meta = {} } = wData;

	return (<HeaderDropDownMenu
		data={data}
		meta = {meta}
		id={id}
		title = {title}	
		faIconClass = {faIconClass}
		mobileDisplayNav = {props.mobileDisplayNav}
		additionalClass='nav-link dropdown-link true-link m-1' />);
}

export default HeaderSubMenu
